import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {STATES_ROUTE, STATES_ROUTE_NEW} from '../http-routes';
import {IState} from '@api/models/state/state';
import { IDefaultListResponse } from '@api/models/default-response/response';

export enum StatesOrder {
  Name = 'name',
  Size = 'size'
}

@Injectable({
  providedIn: 'root'
})
export class StateHttpService {

  private states: IState[];

  constructor(private http: HttpService) { }

  public async getAllStates(): Promise<IState[]> {
    if (!this.states) {
      this.states = await this.http.get<any>([STATES_ROUTE]);
    }
    return this.states;
  }

  public async getStatesForCountry(countryId: string): Promise<IState[]> {
    if (!this.states) {
      this.states = await this.http.get<any>(['countries', countryId, 'states']);
    }
    return this.states;
  }

  public async getStatesSortedBy(order: StatesOrder): Promise<IDefaultListResponse<IState>> {
      return await this.http.get<any>([STATES_ROUTE_NEW, 'sorted', order]);
  }
}
